import React, { useState } from "react";
import "./addbrand.css";

// components imports
import Loader from "../../../../../Components/CircularLoader/CircularLoader";
// apis imports
import { addBrand } from "../../../../../services/warehouse.services";
// library imports
import Modal from "@mui/material/Modal";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import { Input, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../store/common/snackBarSlice";
import { useTranslation } from "react-i18next";

const StyledUploadContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "2px dashed #2d76bf",
  borderRadius: "8px",
  backgroundColor: "var(--color-ui-surface)",
  cursor: "pointer",
  marginBottom: "15px",
});

const AddBrand = ({ open, setOpen, setRefresh }) => {
  const { t } = useTranslation(["inventory", "common"]);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    file: "",
    name: "",
    description: "",
  });
  const dispatch = useDispatch();

  const handelChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (formData.name === "") {

      dispatch(showSnackBar({
        text: t("brands.pleaseEnterBrandName"),
        severity: "error",
      }))
      setLoading(false);
      return;
    }
    if (formData.file === "") {
      dispatch(showSnackBar({
        text: t("brands.pleaseSelectBrandLogo"),
        severity: "error",
      }))
      setLoading(false);
      return;
    }
    const Formdata = new FormData();
    Formdata.append("file", formData.file);
    Formdata.append("name", formData.name);
    Formdata.append("description", formData.description);

    const response = await addBrand(Formdata);
    // console.log("response", response.data.result);
    if (response.error) {
      dispatch(showSnackBar({
        text:
          response?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
        severity: "error",
      }))
      setLoading(false);
    } else {

      dispatch(showSnackBar({
        text: t("brands.brandAddedSuccessfully"),
        severity: "success",
      }))
      setRefresh(Math.floor(Math.random() * 100) + 1);
      setFormData({
        file: "",
        name: "",
        description: "",
      });
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="add-brand-modal-title"
        aria-describedby="add-brand-modal-description"
      >
        <div className="brandStock__add_new_brand_modal">
          <div className="brandStock__add_new_brand_modal_wrap">
            <div className="brandStock__add_new_brand">
              <div className="brandStock__add_new_brand_header">
                <h3 className="brandStock__add_new_brand_title">{t("brands.addBrand")}</h3>
              </div>
              <div className="brandStock__add_new_brand_body">
                <FormControl
                  variant="outlined"
                  className="brandStock__add_new_brand_name"
                >
                  <InputLabel htmlFor="addStockCountName" size="small">
                    {t("brands.nameRequired")}
                  </InputLabel>
                  <OutlinedInput
                    id="addStockCountName"
                    name="name"
                    value={formData?.name}
                    size="small"
                    onChange={(e) => handelChange(e)}
                    label={t("brands.nameRequired")}
                  />
                </FormControl>
                <StyledUploadContainer className="file__upload_csv_row">
                  <label htmlFor="file-upload">
                    <Input
                      id="file-upload"
                      type="file"
                      accept=".jpg,.JPG,.png,.PNG,.gif,.GIF"
                      style={{ display: "none" }}
                      name="file"
                      onChange={(e) =>
                        handelChange({
                          target: { value: e.target.files[0], name: "file" },
                        })
                      }
                    />
                    <Typography variant="h6" color="primary" component="div">
                      {formData.file === ""
                        ? t("brands.uploadLogoToSubmit")
                        : formData?.file?.name}
                    </Typography>
                  </label>
                </StyledUploadContainer>

                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="addStockCountDescription" size="small">
                    {t("brands.description")}
                  </InputLabel>
                  <OutlinedInput
                    id="addStockCountDescription"
                    name="description"
                    value={formData.description}
                    size="small"
                    onChange={(e) => handelChange(e)}
                    label={t("brands.description")}
                    multiline
                    fullWidth
                    rows={5}
                    rowsMax={5}
                  />
                </FormControl>

                <div className="brandStock__add_new_brand_modalfooter">
                  <div
                    className="brandStock__add_new_brand_modalreset"
                    onClick={() => setOpen(false)}
                  >
                    {t("common:actions.cancel")}
                  </div>
                  <div
                    className="brandStock__add_new_brand_modalsubmit"
                    onClick={handleSubmit}
                  >
                    {loading ? <Loader /> : t("common:actions.save")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddBrand;
